import axios from "axios";
import { Promise } from "q";
import { API_URL, STATUS_OK } from "./../../config";

export default class AdminBoardService {
    static loadStats = (username, token) => {
        return new Promise((resolve, reject) => {
            axios
                .get(`${API_URL}users/${username}/stats`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(response => {
                    if (response.status === STATUS_OK) resolve(response.data);
                    else reject(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };
    static loadUsers = (username, token) => {
        return new Promise((resolve, reject) => {
            axios
                .get(`${API_URL}users/${username}/report`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(response => {
                    if (response.status === STATUS_OK) resolve(response.data);
                    else reject(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };
}
